// components/PopupVendor/VendorServicesSection.js
import React from 'react';

const VendorServicesSection = ({
                                   isCurrentUserVendorOwner,
                                   service_subtypes = [],
                                   handlerShowEditServicesPopup
                               }) => {
    if (!isCurrentUserVendorOwner && service_subtypes.length === 0) {
        return null;
    }

    return (
        <div className="profile__block">
            <div className="container">
                <div className="profile__header"><h2>Services</h2>
                    {isCurrentUserVendorOwner && (
                        <button className="button no-style" onClick={handlerShowEditServicesPopup}>
                            <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit Services"/>
                            {(service_subtypes.length === 0) ? 'Add Services' : 'Edit Services'}
                        </button>
                    )}
                </div>
                <div className="profile__content">
                    <ul className="params__list">
                        {service_subtypes.map((subtype, index) => (
                            <li key={index}>{subtype.service_subtype?.name || 'N/A'}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VendorServicesSection;